import React from 'react';
import { Pressable, StyleSheet, View, TouchableHighlight } from 'react-native';
import { SettingsItemDescription, SettingsItemTitle, } from 'design-system/SettingsItem';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
const EditSpaceItem = ({ title, subTitle, leftIcon: LeftIcon, rightIcon: RightIcon, onPress, onPressRight, }) => {
    const colors = useColors();
    const content = (<View style={styles.content}>
      {LeftIcon}
      <View style={styles.texts}>
        <SettingsItemTitle>{title}</SettingsItemTitle>
        <SettingsItemDescription numberOfLines={1} ellipsizeMode="tail">
          {subTitle}
        </SettingsItemDescription>
      </View>
      <Pressable disabled={!onPressRight} style={styles.iconRight} onPress={onPressRight}>
        {RightIcon}
      </Pressable>
    </View>);
    return (<View>
      {onPress ? (<TouchableHighlight onPress={onPress} underlayColor={colors.background.underlay}>
          {content}
        </TouchableHighlight>) : (content)}
    </View>);
};
const styles = StyleSheet.create({
    content: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: rem(16),
        paddingRight: rem(16),
        paddingVertical: rem(16),
    },
    iconRight: {
        width: rem(44),
        height: rem(44),
        justifyContent: 'center',
        alignItems: 'center',
    },
    texts: {
        flexDirection: 'column',
        flex: 1,
        marginLeft: rem(16),
    },
});
export default EditSpaceItem;
